import React from 'react';
import { CalendarIcon, ClockIcon, MonitorIcon, TimerIcon, CheckCircle2Icon } from 'lucide-react';
import { useRegistration } from './RegistrationContext';
import { useWebinarSlot } from './useWebinarSlot';
export const WebinarDetailsCard = () => {
  const {
    openPopup
  } = useRegistration();
  const slot = useWebinarSlot();
  return <section className="mb-12" data-id="element-493">
      <div className="bg-blue-50 border border-blue-100 rounded-xl p-8" data-id="element-494">
        <div className="flex items-center gap-3 mb-6" data-id="element-495">
          <CalendarIcon className="w-6 h-6 text-blue-600" data-id="element-496" />
          <h3 className="text-xl font-bold text-gray-900" data-id="element-497">
            Het volgende <span className="text-blue-600" data-id="element-498">webinar</span>
          </h3>
        </div>

        <div className="space-y-5 mb-8" data-id="element-499">
          <div className="flex items-center" data-id="element-500">
            <CalendarIcon className="w-6 h-6 text-blue-400 mr-4 flex-shrink-0" data-id="element-501" />
            <p className="text-lg text-gray-800" data-id="element-502">
              <span className="font-bold" data-id="element-503">Datum:</span> {slot.dayPrefix}{' '}
              {slot.dateLabel}
            </p>
          </div>
          <div className="flex items-center" data-id="element-504">
            <ClockIcon className="w-6 h-6 text-blue-400 mr-4 flex-shrink-0" data-id="element-505" />
            <p className="text-lg text-gray-800" data-id="element-506">
              <span className="font-bold" data-id="element-507">Tijd:</span> {slot.time}
            </p>
          </div>
          <div className="flex items-center" data-id="element-508">
            <MonitorIcon className="w-6 h-6 text-blue-400 mr-4 flex-shrink-0" data-id="element-509" />
            <p className="text-lg text-gray-800" data-id="element-510">
              <span className="font-bold" data-id="element-511">Locatie:</span> Online (link wordt na
              registratie verstuurd)
            </p>
          </div>
          <div className="flex items-center" data-id="element-512">
            <TimerIcon className="w-6 h-6 text-blue-400 mr-4 flex-shrink-0" data-id="element-513" />
            <p className="text-lg text-gray-800" data-id="element-514">
              <span className="font-bold" data-id="element-515">Duur:</span> 90 minuten
            </p>
          </div>
          <div className="flex items-center" data-id="element-516">
            <CheckCircle2Icon className="w-6 h-6 text-green-500 mr-4 flex-shrink-0" data-id="element-517" />
            <p className="text-lg text-gray-800" data-id="element-518">
              <span className="font-bold" data-id="element-519">Kosten:</span> 100% GRATIS
            </p>
          </div>
        </div>

        <div className="bg-white border border-gray-200 rounded-lg p-5 mb-6" data-id="element-520">
          <p className="font-bold text-gray-900 mb-2 italic" data-id="element-521">Belangrijk:</p>
          <p className="text-gray-600 leading-relaxed" data-id="element-522">
            Er zijn beperkte plekken beschikbaar per uitzending. Elke maand
            melden zich meer mensen aan, dus reserveer snel je plek!
          </p>
        </div>

        <button onClick={openPopup} className="w-full bg-green-700 hover:bg-green-800 text-white font-bold py-4 px-6 rounded-xl transition-colors text-lg" data-id="element-523">
          RESERVEER MIJN PLEK - GRATIS AANMELDEN
        </button>
      </div>
    </section>;
};